<app-capture-history-item-title>
  Associated Patient Interaction Location Added
</app-capture-history-item-title>

<app-capture-history-item-body>
  <span class="phi">{{ note }}</span>
</app-capture-history-item-body>
